import React from 'react'
import { Bar } from 'react-chartjs-2'

/**
 * Composant pour le graphique de logs (Bar)
 */
const LogChart = ({ data, options }) => {
  if (!data || !options || !data.labels || !data.datasets || data.datasets.length === 0) {
    return null
  }

  return (
    <Bar 
      id="chart_log" 
      options={options} 
      data={data} 
    />
  )
}

export default LogChart
